let breakpoints,
	currentBreakpoint;

function init(settings) {
	_validateBreakpoints(settings.breakpoints);

	breakpoints = JSON.parse(JSON.stringify(settings.breakpoints));
	currentBreakpoint = getCurrentBreakpoint();

	_setEventListeners();
}

function _setEventListeners() {
	window.advert.pubsub.subscribe('resize', function() {
		const previousBreakpoint = currentBreakpoint;

		currentBreakpoint = getCurrentBreakpoint();

		if (previousBreakpoint !== currentBreakpoint) {
			window.advert.pubsub.publish('breakpoint.changed', currentBreakpoint);
		}
	});
}

function _validateBreakpoints(bps) {
	const values = [];

	Object.keys(bps).forEach((bp) => {
		if (typeof bps[bp] !== 'number' || bps[bp] < 0) {
			throw new Error(`Invalid breakpoint '${bp}'. '${bps[bp]}' is not a number or less than zero.`);
		}

		if (values.indexOf(bps[bp]) !== -1) {
			throw new Error(`Invalid breakpoint '${bp}'. Breakpoint at '${bps[bp]}' already exists.`);
		}

		values.push(bps[bp]);
	});

	let lowest = Math.min(...values);

	if (lowest > 0) {
		bps['0'] = 0;
	}
}

function getCurrentBreakpoint() {
	const screenWidth = window.advert.screen.getSize().width;

	return Object.keys(breakpoints).reduce((agg, bp) => {
		if (breakpoints[bp] <= screenWidth && breakpoints[bp] > breakpoints[agg]) {
			agg = bp;
		}

		return agg;
	});
}

function getBreakpoints() {
	return breakpoints;
}

module.exports = {
	init,
	getCurrentBreakpoint,
	getBreakpoints
};
